module.exports = __webpack_public_path__ + "static/assets/538a6bac80408cb491cf0c6af10c6f3d.png";